import styled from 'styled-components';
import { getSpace, px2rem, mq } from '../../../../stylesheets/tools';

const StyledEducationTabletProcess = styled.section`
  padding: ${getSpace('l')} 0;

  ${mq('m')} {
    padding: ${getSpace('xl')} 0;
  }

  .process__header {
    margin-bottom: ${getSpace('l')};
    display: flex;
    align-items: center;
    gap: ${px2rem('20px')};

    .process__header-time {
      display: none;

      ${mq('m')} {
        display: flex;
      }
    }
  }
  .process__grid {
    display: flex;
    flex-direction: column;
    gap: ${px2rem('30px')};
  }
`;

export default StyledEducationTabletProcess;
